import { render, staticRenderFns } from "./DeletedDocuments.vue?vue&type=template&id=9ee186c2&"
import script from "./DeletedDocuments.vue?vue&type=script&lang=js&"
export * from "./DeletedDocuments.vue?vue&type=script&lang=js&"
import style0 from "./DeletedDocuments.vue?vue&type=style&index=0&id=9ee186c2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports